"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerbId = void 0;
// Declare this key type and export the NotificationId to make this behave like a string enum.
//
// PLEASE KEEP IN ALPHABETICAL ORDER. This helps with visually finding entries, knowing where to put
// new ones, and merge conflicts.
var VerbId;
(function (VerbId) {
    VerbId["ActivateNextStoryPoint"] = "activate-next-story-point";
    VerbId["ActivatePreviousStoryPoint"] = "activate-previous-story-point";
    VerbId["ActivateSheet"] = "activateSheet";
    VerbId["ActivateStoryPoint"] = "activate-story-point";
    VerbId["AddMarksCardFields"] = "add-marks-card-fields";
    VerbId["AppendExternalMenuItem"] = "append-external-menu-item";
    VerbId["ApplyCategoricalFilter"] = "categorical-filter";
    VerbId["ApplyPulseFilters"] = "apply-pulse-filters";
    VerbId["ApplyPulseTimeDimension"] = "apply-pulse-time-dimension";
    VerbId["ApplyRangeFilter"] = "range-filter";
    VerbId["ApplyRelativeDateFilter"] = "apply-relative-date-Filter";
    VerbId["Authenticate"] = "authenticate";
    VerbId["BlockExtension"] = "block-extension";
    VerbId["ChangeParameterValue"] = "change-parameter-value";
    VerbId["ChangeSharedFilter"] = "change-shared-filter";
    VerbId["ClearAllPulseFilters"] = "clear-all-pulse-filters";
    VerbId["ClearFilter"] = "clear-filter";
    VerbId["ClearPulseFilters"] = "clear-pulse-filters";
    VerbId["ClearSelectedMarks"] = "clear-selected-marks";
    VerbId["CloseDialog"] = "close-dialog";
    VerbId["CreateAnnotation"] = "create-annotation";
    VerbId["DashboardCategoricalFilter"] = "dashboard-categorical-filter";
    VerbId["DisplayDialog"] = "display-dialog";
    VerbId["DownloadWorkbook"] = "download-workbook";
    VerbId["EditAliasesDialog"] = "edit-aliases-dialog";
    VerbId["ExecuteExternalMenuItem"] = "execute-external-menu-item";
    VerbId["ExportCrosstab"] = "export-crosstab";
    VerbId["ExportCrosstabCsvDownload"] = "export-crosstab-csv-download";
    VerbId["ExportCrosstabExcelDownload"] = "export-crosstab-excel-download";
    VerbId["ExportData"] = "export-data";
    VerbId["ExportDataDownload"] = "export-data-download";
    VerbId["ExportImage"] = "export-image";
    VerbId["ExportPdf"] = "export-pdf";
    VerbId["ExportPdfDownload"] = "export-pdf-download";
    VerbId["ExportPowerpoint"] = "export-powerpoint";
    VerbId["ExportPowerpointDownload"] = "export-powerpoint-download";
    VerbId["FindParameter"] = "find-parameter";
    VerbId["GetActiveTables"] = "get-active-tables";
    VerbId["GetAllDataSources"] = "get-all-data-sources";
    VerbId["GetAnnotations"] = "get-annotations";
    VerbId["GetCategoricalDomain"] = "get-categorical-domain";
    VerbId["GetConnectionDescriptionSummaries"] = "get-connection-description-summaries";
    VerbId["GetCurrentSrc"] = "get-current-src";
    VerbId["GetCustomViews"] = "get-custom-views";
    VerbId["GetDashboardFilters"] = "get-dashboard-filters";
    VerbId["GetDataSource"] = "get-datasource";
    VerbId["GetDataSourceData"] = "get-datasource-data";
    VerbId["GetDataSources"] = "get-data-sources";
    VerbId["GetDataSummaryData"] = "get-summary-data";
    VerbId["GetDataSummaryDataReader"] = "get-summary-data-reader";
    VerbId["GetDataTableReaderPage"] = "get-data-table-reader-page";
    VerbId["GetEmbeddingAbstractQueryWithDataModel"] = "get-embedding-abstract-query-with-data-model";
    VerbId["GetEmbeddingClientInfo"] = "get-embedding-client-info";
    VerbId["GetVizStateWithDataModel"] = "get-viz-state-with-data-model";
    VerbId["GetExportCrosstabSheetMap"] = "get-export-crosstab-sheet-map";
    VerbId["GetExportPdfOptions"] = "get-export-pdf-options";
    VerbId["GetField"] = "get-field";
    VerbId["GetFieldAndDataSource"] = "get-field-and-datasource";
    VerbId["GetVisualSpecification"] = "get-visual-specification";
    VerbId["GetFilters"] = "get-filters";
    VerbId["GetFonts"] = "get-fonts";
    VerbId["GetHighlightedMarks"] = "get-highlighted-marks";
    VerbId["GetJoinDescription"] = "get-join-description";
    VerbId["GetLogicalTableData"] = "get-logical-table-data";
    VerbId["GetLogicalTableDataReader"] = "get-logical-table-data-reader";
    VerbId["GetLogicalTables"] = "get-logical-tables";
    VerbId["GetParametersForSheet"] = "get-parameters-for-sheet";
    VerbId["GetPulseCategoricalDomain"] = "get-pulse-categorical-domain";
    VerbId["GetPulseFilters"] = "get-pulse-filters";
    VerbId["GetPulseTimeDimension"] = "get-pulse-time-dimension";
    VerbId["GetRangeDomain"] = "get-range-domain";
    VerbId["GetSelectedMarks"] = "get-selected-marks";
    VerbId["GetSharedFilter"] = "get-shared-filter";
    VerbId["GetTooltipText"] = "get-tooltip-text";
    VerbId["GetUnderlyingData"] = "get-underlying-data";
    VerbId["GetUnderlyingTableData"] = "get-underlying-table-data";
    VerbId["GetUnderlyingTableDataReader"] = "get-underlying-table-data-reader";
    VerbId["GetUnderlyingTables"] = "get-underlying-tables";
    VerbId["HierarchicalFilter"] = "hierachical-filter";
    VerbId["InitializeExtension"] = "initialize-extension";
    VerbId["IsAnalyticsAssistantAvailable"] = "is-analytics-assistant-available";
    VerbId["LaunchAnalyticsAssistant"] = "launch-analytics-assistant";
    VerbId["MoveAndResizeZones"] = "move-and-resize-zones";
    VerbId["MoveMarksCardField"] = "move-marks-card-field";
    VerbId["RaiseLeaveMarkNavNotification"] = "raise-leave-mark-nav-notification";
    VerbId["RaiseHoverTupleNotification"] = "raise-hover-tuple-notification";
    VerbId["RaiseSelectTuplesNotification"] = "raise-select-tuples-notification";
    VerbId["Redo"] = "redo";
    VerbId["RefreshDataSource"] = "refresh-data-source";
    VerbId["ReleaseDataTableReader"] = "release-data-table-reader";
    VerbId["RemoveAnnotation"] = "remove-annotation";
    VerbId["RemoveCustomView"] = "remove-custom-view";
    VerbId["RemoveExternalMenuItem"] = "remove-external-menu-item";
    VerbId["RenameExternalMenu"] = "rename-external-menu";
    VerbId["ReplayAnimation"] = "replay-animation";
    VerbId["ReportExtensionRenderComplete"] = "report-extension-render-complete";
    VerbId["RevertStoryPoint"] = "revert-story-point";
    VerbId["RevertWorkbook"] = "revert-workbook";
    VerbId["SaveExtensionSettings"] = "save-extension-settings";
    VerbId["SaveWorkbookAsCustomView"] = "save-workbook-as-custom-view";
    VerbId["SelectByValue"] = "select-by-value";
    VerbId["SetActiveCustomViewAsDefault"] = "set-active-custom-view-as-default";
    VerbId["SetAutoUpdate"] = "set-auto-update";
    VerbId["SetClickThrough"] = "set-click-through";
    VerbId["SendDialogMessage"] = "send-dialog-message";
    VerbId["SendMessageToParent"] = "send-message-to-parent";
    VerbId["SetVizStateWithDataModel"] = "set-viz-state-with-data-model";
    VerbId["SetSheetSize"] = "set-sheet-size";
    VerbId["SetZoneVisibility"] = "set-zone-visibility";
    VerbId["Share"] = "share";
    VerbId["ShowCustomView"] = "show-custom-view";
    VerbId["SpliceMarksCardFields"] = "splice-marks-card-fields";
    VerbId["TestConversionVerb"] = "test-conversion-verb";
    VerbId["Undo"] = "undo";
    VerbId["UpdateCustomView"] = "update-custom-view";
    VerbId["VizAPI"] = "viz-api";
})(VerbId || (exports.VerbId = VerbId = {}));
//# sourceMappingURL=Verbs.js.map